module.exports = __webpack_public_path__ + "media/teaser-dezyr-final-cut.690e1058.mp4";